import {IGeneralEdit} from './dtos/general-edit';

import {IPaginateProducts} from '../../../common-dtos/get-all-paginate';
import ApiService from '../../../utils/base-api/api-service';
import {IBrandProducts} from './dtos/brand-list';
import {IShopDetails} from './dtos/shop-details';
import {IEditWareHouse} from './dtos/edit-warehouse';
import {IEditCommission} from './dtos/update-commission';
import {IRejectShop, IShopRegistrationStatus} from './dtos/reject-shop';

class ShopInfoService extends ApiService {
  constructor() {
    super({
      baseURL: '/ShopInfoAdmin',
    });
  }

  getAllBrands(queryPaginate?: IPaginateProducts & { Keyword?: string }): Promise<IBrandProducts> {
    return this.get('/GetAllBrands', {
      params: queryPaginate,
    });
  }
  getShopDetails(shopId?: string): Promise<IShopDetails> {
    return this.get('/Details', {
      params: {id: shopId},
    });
  }

  generalEdit(updatedData: IGeneralEdit): Promise<any> {
    return this.post('/GeneralEdit', updatedData);
  }

  editWareHouse(updatedData: IEditWareHouse): Promise<any> {
    return this.post('/EditWareHosue', updatedData);
  }

  updateCommission(updatedData: IEditCommission) {
    return this.post('/UpdateCommission', undefined, {
      params: {
        ...updatedData,
      },
    });
  }

  rejectShop(shopReject: IRejectShop): Promise<IShopRegistrationStatus> {
    return this.post('/Reject', undefined, {
      params: shopReject,
    });
  }

  approveShop(shopId: string): Promise<IShopRegistrationStatus> {
    return this.post('/Approve', undefined, {
      params: {
        id: shopId,
      },
    });
  }
}

export const shopInfoServices = new ShopInfoService();
